import notificationSaga from './addNotification';

export default [notificationSaga];
